import React, { useState } from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import LungCancerComp from "../components/LungCancerComp";
import ThyroidCancerMain from "../components/ThyroidCancerMain";

import ThyroidVideo from "../components/ThyroidVideo";
import ThyroidVideoComple from "../components/ThyroidVideo/ThyroidVideoComple";
import ThyroidDecision from "../components/ThyroidVideo/ThyroidDecision";
import Layout from "../components/layout/Layout";
// import LungMain from "../components/LungMain";
// import LungForm from "../components/LungMain/LungForm";

const ThyroidCancer = () => {
  let { path } = useRouteMatch();
  const [vi, setVi] = useState(0);
  // const [sopen, setSopen] = useState(false);
  const handleChange = (num = 0) => {
    setVi(num);
  };
  return (
    <>
      <Switch>
        <Route exact path={`${path}`}>
          <ThyroidCancerMain />
        </Route>
        <Route path={`${path}/calculate`}>
          <Layout>
            <LungCancerComp />
          </Layout>
        </Route>

        <Route path={`${path}/video`}>
          {vi === 0 ? (
            <ThyroidVideo onViChange={handleChange} />
          ) : (
            <Layout>
              {vi === 1 ? (
                <ThyroidVideoComple onViChange={handleChange} vi={vi} />
              ) : (
                <ThyroidDecision onViChange={handleChange} vi={vi} />
              )}
            </Layout>
          )}
        </Route>
      </Switch>
    </>
  );
};

export default ThyroidCancer;
